import React, { useEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useAppSelector } from "../../app/hooks";
import { selectNotification } from "../session/sessionSlice";

export const NotificationSnackBar = () => {
  const [open, setOpen] = React.useState(false);
  const notification = useAppSelector(selectNotification);
  useEffect(() => {
    if (notification?.message) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [notification]);

  const handleClose = (_?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  return (
    <Snackbar
      key={notification?.message}
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
      style={{ pointerEvents: "none" }}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <MuiAlert
        variant="filled"
        onClose={handleClose}
        severity={notification?.type}
        sx={{ width: "100%", marginBottom: 8, pointerEvents: "auto" }}
      >
        {notification?.message}
      </MuiAlert>
    </Snackbar>
  );
};
